export const Button = ({ children, variant = "primary", size = "default", className = "", disabled = false, ...props }) => {
  const baseStyles = `
    inline-flex items-center justify-center gap-2.5
    font-semibold tracking-wide
    rounded-full border-none cursor-pointer
    transition-all duration-[200ms] ease-[cubic-bezier(0.34,1.56,0.64,1)]
    disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none
    active:scale-[0.95] active:transition-transform active:duration-[150ms]
    hover:scale-[1.02] hover:-translate-y-0.5
    relative overflow-hidden
  `;

  const variants = {
    primary: `
      bg-[#2D4A2A] text-white
      hover:bg-[#3D5A34] hover:shadow-[0_0_36px_rgba(45,74,42,0.30)] hover:-translate-y-0.5
      active:bg-[#1F3620] active:translate-y-0
    `,
    secondary: `
      bg-transparent text-[#2D4A2A] 
      border-2 border-[#2D4A2A]
      hover:bg-[rgba(45,74,42,0.08)] hover:-translate-y-0.5
      active:translate-y-0
    `,
    ghost: `
      bg-transparent text-[#2D4A2A]
      hover:bg-[rgba(45,74,42,0.08)]
    `,
    accent: `
      bg-[#B8956C] text-white
      hover:bg-[#CDAB82] hover:shadow-[0_0_36px_rgba(184,149,108,0.40)] hover:-translate-y-0.5
      active:translate-y-0
    `,
    premium: `
      bg-gradient-to-r from-[#B8956C] via-[#CDAB82] to-[#9A7B56] text-white
      hover:opacity-95 hover:shadow-[0_0_40px_rgba(184,149,108,0.45)] hover:-translate-y-0.5
      active:translate-y-0
      shimmer
    `,
    outline: `
      bg-white text-[#2D4A2A] 
      border-2 border-[#2D4A2A]
      hover:bg-[#2D4A2A] hover:text-white hover:-translate-y-0.5
      active:translate-y-0
    `,
    soft: `
      bg-[#2D4A2A]/10 text-[#2D4A2A]
      hover:bg-[#2D4A2A]/15 hover:-translate-y-0.5
      active:translate-y-0
    `,
  };

  const sizes = {
    sm: "px-5 py-2.5 text-sm",
    default: "px-7 py-4 text-[15px]",
    lg: "px-9 py-5 text-base",
    icon: "p-3.5",
  };

  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={disabled}
      {...props}
    >
      {/* Subtle shine overlay */}
      <span className="absolute inset-0 bg-gradient-to-b from-white/15 to-transparent pointer-events-none" />
      <span className="relative flex items-center gap-2">{children}</span>
    </button>
  );
};
